
import { Typography, Box, Grid, Button } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Minimize from '@material-ui/icons/Minimize';
import AddIcon from '@material-ui/icons/Add';
import React, { useState } from 'react';

import { buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';


const PatientProfilePersonalInformation = props => {
    const [expandedPanel, setExpandedPanel] = useState(false);

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedPanel(isExpanded ? panel : false);
    };


    let profile = props.profile;
    let dateOfBirthYear = props.dateOfBirthYear;


    return (

        <Box style={{ paddingTop: "30px" }}>

            <Accordion onChange={handleAccordionChange('panel1')}>
                <AccordionSummary

                    expandIcon={
                        expandedPanel ? <Minimize /> :
                            <AddIcon />
                    }

                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    {!expandedPanel &&
                        <Typography>Personal Details</Typography>
                    }
                    {expandedPanel &&
                        <Box style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                            <Box style={{ width: "15%" }}>
                                <Box style={{ display: "flex" }}>
                                    <Typography style={{
                                        fontSize: 20,
                                        fontWeight: "bold",
                                        wordBreak: "break-all"
                                    }} title={profile.firstName + " " + profile.lastName}>
                                        {profile.firstName}{" "}{profile.lastName}
                                    </Typography>
                                </Box>
                                <Box display={props.dateOfBirth !== 'Invalid Date' ? 'block' : 'none'}>
                                    <Typography>{props.dateOfBirth}</Typography>
                                </Box>
                                <Box display={props.dateOfBirth === 'Invalid Date' ? 'block' : 'none'}>
                                    <Typography>--</Typography>
                                </Box>
                            </Box>
                            <Box style={{ width: "15%" }}>
                                <Box style={{ display: "flex" }}>
                                    <Typography style={{ fontWeight: "bold" }}>
                                        Race / Ethnicity
                                    </Typography>
                                </Box>
                                <Typography>
                                    {profile.races?.map((race, i) => {
                                        return (
                                            <>
                                                {race}
                                                {i !== profile.races.length - 1 &&
                                                    <span>, </span>

                                                }
                                            </>
                                        )
                                    })}
                                </Typography>
                            </Box>
                            <Box style={{ width: "15%" }}>
                                <Box style={{ display: "flex" }}>
                                    <Typography style={{ fontWeight: "bold" }}>
                                        Gender Identities
                                    </Typography>
                                </Box>
                                <Box style={{ display: "flex" }}>
                                    <Typography>{profile.genderIdentity}</Typography>
                                </Box>
                            </Box>
                            <Box style={{ width: "15%" }}>
                                <Box style={{ display: "flex" }}>
                                    <Typography style={{ fontWeight: "bold" }}>
                                        Sexual Preference
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography>
                                        {profile.sexualPreferences?.map((sexualPreference, i) => {
                                            return (
                                                <>
                                                    {sexualPreference}
                                                    {i !== profile.sexualPreferences.length - 1 &&
                                                        <span>, </span>

                                                    }
                                                </>
                                            )
                                        })}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box style={{ width: "15%" }}>
                                <Box style={{ display: "flex" }}>
                                    <Typography style={{ fontWeight: "bold" }}>
                                        Username / Email
                                    </Typography>
                                </Box>
                                <Box style={{ display: "flex" }}>
                                    <Typography style={{ wordBreak: "break-all" }}>
                                        {profile.email}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box style={{ width: "15%" }}>
                                <Box style={{ display: "flex" }}>
                                    <Typography style={{ fontWeight: "bold" }}>
                                        Relationship Status
                                    </Typography>
                                </Box>
                                <Box><Typography>{profile.relationshipStatus}</Typography></Box>
                            </Box>
                        </Box>
                    }
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container>
                        <Grid item style={{ display: "flex", justifyContent: "space-between", width: "100%" }} >
                            <div style={{ width: "15%", flexDirection: "column" }}>
                                <div style={{ textAlign: "center" }}>
                                    <CircularProgressbarWithChildren strokeWidth={3}
                                        value={Math.round((profile.currentChildrenQty / profile.desiredChildrenQty) * 100)}
                                        styles={buildStyles({
                                            textColor: "black",
                                            pathColor: "#1FA19D",

                                        })}>
                                        <div style={{ fontSize: 50, marginTop: -5 }}>
                                            <strong>{profile.currentChildrenQty}</strong>
                                        </div>
                                        <div style={{ fontSize: 12, marginTop: -5 }}>
                                            <hr style={{ width: "30px" }}></hr>
                                        </div>
                                        <div style={{ fontSize: 50, marginTop: -5 }}>
                                            <strong>{profile.desiredChildrenQty}</strong>
                                        </div>
                                    </CircularProgressbarWithChildren>
                                </div>
                            </div>

                            <div style={{ width: "15%", flexDirection: "column" }}>
                                <div style={{ textAlign: "center" }}>
                                    <CircularProgressbarWithChildren value={0} strokeWidth={3}>
                                        {profile.firstPeriodAge === "I haven't started my first period" ?
                                            <>
                                                <div style={{ fontSize: 17, color: 'rgb(74,97,138)' }}>
                                                    <strong>{profile.firstPeriodAge}</strong>
                                                </div>
                                            </> :
                                            <>
                                                <div style={{ fontSize: 80, marginTop: -5, color: 'rgb(74,97,138)' }}>
                                                    <strong>{profile.firstPeriodAge}</strong>
                                                </div>
                                                <div style={{ fontSize: 30, marginTop: -30, color: 'rgb(74,97,138)' }}>
                                                    <strong>{dateOfBirthYear + parseInt(profile.firstPeriodAge)}</strong>
                                                </div>
                                            </>
                                        }
                                    </CircularProgressbarWithChildren>
                                </div>
                            </div>
                            <div style={{ width: "15%", flexDirection: "column" }}>
                                <div style={{ textAlign: "center" }}>
                                    <CircularProgressbarWithChildren value={0} strokeWidth={3}>
                                        {profile.sexuallyActiveAge === "I am not yet sexually active" ?
                                            <>
                                                <div style={{ fontSize: 17, color: 'rgb(74,97,138)' }}>
                                                    <strong>{profile.sexuallyActiveAge}</strong>
                                                </div>
                                            </> :
                                            <>
                                                <div style={{ fontSize: 80, marginTop: -5, color: 'rgb(74,97,138)' }}>
                                                    <strong>{profile.sexuallyActiveAge}</strong>
                                                </div>
                                                <div style={{ fontSize: 30, marginTop: -30, color: 'rgb(74,97,138)' }}>
                                                    <strong>{dateOfBirthYear + parseInt(profile.sexuallyActiveAge)}</strong>
                                                </div>
                                            </>
                                        }
                                    </CircularProgressbarWithChildren>
                                </div>
                            </div>
                            <div style={{ width: "15%", flexDirection: "column" }}>
                                <div style={{ textAlign: "center" }}>
                                    <CircularProgressbarWithChildren value={0} strokeWidth={3}>
                                        <div style={{ fontSize: 80, marginTop: -5, color: 'rgb(74,97,138)' }}>
                                            <strong> {(profile.menopauseAge) ? profile.menopauseAge : '0'}</strong>
                                        </div>
                                        <div style={{ fontSize: 30, marginTop: -30, color: 'rgb(74,97,138)' }}>
                                            <strong> {(profile.menopauseAge) ? dateOfBirthYear + profile.menopauseAge : ''}</strong>
                                        </div>
                                    </CircularProgressbarWithChildren>
                                </div>
                            </div>
                            <div style={{ width: "20%", alignSelf: "center" }}>
                                <div style={{ display: "flex", alignSelf: "center" }}>
                                    <div style={{ width: "40%" }}>
                                        <div style={{ textAlign: "center" }}>
                                            <CircularProgressbarWithChildren value={0} strokeWidth={3}>
                                                <div style={{ fontSize: 50, marginTop: -5, color: 'rgb(74,97,138)' }}>
                                                    {profile && profile.childbearingYearFrame &&
                                                        <strong>{profile.childbearingYearFrame[0]}</strong>
                                                    }
                                                </div>
                                            </CircularProgressbarWithChildren>
                                        </div>
                                    </div>
                                    <div style={{ width: "10%", margin: "auto" }}>
                                        <hr style={{ width: "100%" }}></hr>
                                    </div>
                                    <div style={{ width: "40%" }}>
                                        <div style={{ textAlign: "center" }}>
                                            <CircularProgressbarWithChildren value={0} strokeWidth={3}>
                                                <div style={{ fontSize: 50, marginTop: -5, color: 'rgb(74,97,138)' }}>
                                                    {profile && profile.childbearingYearFrame &&
                                                        <strong>{profile.childbearingYearFrame[1]}</strong>
                                                    }
                                                </div>
                                            </CircularProgressbarWithChildren>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </Grid>

                        <Grid item style={{ display: "flex", justifyContent: "space-between", width: "100%", marginTop: "10px" }} >

                            <div style={{ width: "15%", flexDirection: "column" }}>
                                <div style={{ textAlign: "center" }}>
                                    <span>
                                        living children : {profile.currentChildrenQty}
                                        <br />
                                        desired children : {profile.desiredChildrenQty}
                                    </span>
                                </div>
                            </div>
                            <div style={{ width: "15%", flexDirection: "column", textAlign: "center" }}>
                                Menstruation Onset
                            </div>
                            <div style={{ width: "15%", flexDirection: "column", textAlign: "center" }}>
                                Sexual Debut
                            </div>
                            <div style={{ width: "15%", flexDirection: "column", textAlign: "center" }}>
                                Menopause Onset
                            </div>
                            <div style={{ width: "20%", textAlign: "center" }} >
                                <span>
                                    Desired child bearing Window
                                </span>
                            </div>
                        </Grid>

                        <Grid item xl={12} md={12} sm={12} xs={12} style={{ display: "flex", justifyContent: "space-between" }}>
                            <div style={{ width: "15%", textAlign: "center" }}>
                                <Button fullWidth style={{ backgroundColor: "#d2dbe5", borderRadius: "30px", cursor: "default" }}><b style={{ cursor: "text" }}>FPQ</b></Button>
                            </div>
                            <div style={{ width: "85%", textAlign: "center" }}>
                                <Button fullWidth style={{ backgroundColor: "#d2dbe5", width: "70%", borderRadius: "30px", textTransform: "none", cursor: "default" }}>
                                    <b style={{ cursor: "text" }}>Patient Reproductive Health Timeline</b></Button>
                            </div>
                        </Grid>

                    </Grid>

                </AccordionDetails>
            </Accordion>
        </Box>


    )
}

export default PatientProfilePersonalInformation;